var TrendChart = require("common/charts/trend-chart");

var consumptionConfiguration = {
    element: 'alert-consumption-graph',
    type: 'daily',
    force_max: true,
    agg_examples_mode: true,
    maxValue: 100,
    templates: {
      normalized: _.template("Consumption <%= parseFloat(consumption.toFixed(1)) %>, <%= (consumptionAvg > 0) ? '+' : '' %><%= consumptionAvg %>% from Avg")
    }
};

module.exports = angular.module(__filename, [
    require('data/insights/alerts-insights-service').name
]).controller("alertsV2ConsumptionGraph", ['$scope', '$timeout', 'close', 'interest', 'alert', 'alertsV2Service', function ($scope, $timeout, close, interest, alert, alertsService) {
    var trigger = alert.triggers.compare_to_average;
    $scope.alert = alert;
    $scope.close = close;
    init();
    $scope.legend = function () {
        var value = 1;
        var unit = 'STDev';
        if (trigger.is_active) {
            value = trigger[trigger.value_type];
            unit = ({sentiment_points: 'pts.', percentage: '%'})[trigger.value_type]
        }
        return `${Math.abs(value)}${unit} ${(value < 0 || $scope.decreaseAlert) ? 'Below' : 'Above'} Average`
    };

    function init() {
        $scope.graphOptions = Object.assign({}, consumptionConfiguration, calcGraphBounds(alert.sentiment_type == 'neutral'));
        switch (alert.type) {
            case 'sentiment':
                $scope.alertType = _.find(alertsService.sentimentTypes, {id: alert.sentiment_type}).label;
                $scope.decreaseAlert = !alert.is_increase;
                $scope.avgLineTitle = 'Average';
                break;
            case 'consumption':
                $scope.alertType = _.capitalize(alert.type);
                $scope.avgLineTitle = 'Moving Average';
                break;
        }

        $scope.title = `${interest.text} Monthly ${$scope.alertType} Trend`;
    }

    function calcGraphBounds(withNegative) {
        var stdevData = _.find(interest.graphData.chart, ["term.text", "STDev"]);
        var maxValue = _.maxBy(stdevData.series, "value").value;
        var minValue = _.minBy(stdevData.series, "value").value;
        return {
            minValue: (withNegative ? Math.min(-90, minValue) : Math.min(10, minValue)) - 10,
            maxValue: Math.max(90, maxValue) + 10
        }
    }

    function draw() {
        $scope.trends = _.map(interest.graphData.chart, 'term');
        $timeout(function () {
            var chart = new TrendChart(this, $scope.graphOptions.element, $scope.graphOptions);
            chart.draw(interest.graphData, $scope.graphOptions.maxValue, "normalized", null, false, false);
            chart.addCircles(interest.examples, false);
        });
    }

    draw();
}]);
